// extracted by mini-css-extract-plugin
export default {"events":"NotificationEventItems-events-dl1MD"};